import CT_dhanya from "../assets/team/CT_dhanya.png"
import shilpi_img from "../assets/team/shilpi.png"
import gaurav_img from "../assets/team/gaurav.jpeg"
import saksham_img from "../assets/team/saksham.jpg"
import nirmal_img from "../assets/team/nirmal.jpg"
import ajay_img from "../assets/team/ajay.jpg"
import abhinav_img from "../assets/team/abhinav.jpg"
import nidhi_img from "../assets/team/nidhi.jpg"
import mansi_img from "../assets/team/mansi.png"
import lakshya_img from "../assets/team/lakshya.png"
import chirag_img from "../assets/team/chirag.jpg"
import deeptanshu_img from "../assets/team/Deeptanshu_prattya.jpeg"
import khushi_img from "../assets/team/Khushi_parihar.png"
import nilanjana_img from "../assets/team/Nilanjana_jain.jpg"
import punyansh_img from "../assets/team/Punyansh.jpg"
import shreyas_img from "../assets/team/Shreyas.jpg"
import teesta_img from "../assets/team/Teesta_sarkar.png"
import adarsha_img from "../assets/team/Adarsha_mora.jpg"
import narender_img from "../assets/team/narender.jpg"

const team_members = {
    "faculty_head": [
        {
            "name": "Prof. Dhanya C. T.", 
            "role": "Dean (Academics)",
            "image": CT_dhanya
        },
        {
            "name": "Prof. Shilpi Sharma",
            "role": "Associate Dean Academics (Outreach & New Initiatives)",
            "image": shilpi_img
        }
    ],
    "staff_members": [
        {
            "name": "Saksham Saraswat",
            "role": "Staff Member, IIT Delhi",
            "image": saksham_img
        },
        {
            "name": "Gaurav",
            "role": "Staff Member, IIT Delhi",
            "image": gaurav_img
        },
        {
            "name": "Ajay Kumar",
            "role": "Staff Member, IIT Delhi",
            "image": ajay_img
        },
        {
            "name": "Abhinav",
            "role": "Staff Member, IIT Delhi",
            "image": abhinav_img
        },
        {
            "name": "Nidhi Dutta",
            "role": "Jr. Assistant, IIT Delhi",
            "image": nidhi_img
        },
        {
            "name": "Nirmal Kumar",
            "role": "Staff Member, IIT Delhi",
            "image": nirmal_img
        },
        {
            "name": "Narender Singh Mehra",
            "role": "Staff Member, IIT Delhi",
            "image": narender_img
        }
    ],
    "student_members": [
        {
            "vertical": "Secretaries",
            "members": [
                {
                    "name": "Mansi Bhat",
                    "role": "General Secretary",
                    "image": mansi_img
                },
                {
                    "name": "Lakshya Baid",
                    "role": "Deputy General Secretary",
                    "image": lakshya_img
                }
            ]
        },
        {
            "vertical": "Content and Creatives",
            "members": [
                {
                    "name": "Deeptanshu Prattya",
                    "role": "Coordinator",
                    "image": deeptanshu_img
                },
                {
                    "name": "Teesta Sarkar",
                    "role": "Coordinator",
                    "image": teesta_img
                }
            ]
        },
        {
            "vertical": "Technical",
            "members": [
                {
                    "name": "Adarsha Mora",
                    "role": "Coordinator",
                    "image": adarsha_img
                }
            ]
        },
        {
            "vertical": "Events",
            "members": [
                {
                    "name": "Khushi Parihar",
                    "role": "Coordinator",
                    "image": khushi_img
                },
                {
                    "name": "M Shreyas",
                    "role": "Coordinator",
                    "image": shreyas_img
                },
                {
                    "name": "Nilanjana Jain",
                    "role": "Coordinator",
                    "image": nilanjana_img
                }
            ]
        },
        {
            "vertical": "Marketing",
            "members": [
                {
                    "name": "Chirag Dagar",
                    "role": "Coordinator",
                    "image": chirag_img
                },
                {
                    "name": "Punyansh",
                    "role": "Coordinator",
                    "image": punyansh_img
                }
            ]
        }
    ]
}

export default team_members;